// Precios SIEMPRE con 2 decimales (mostrar 12,00 € en vez de 12 €).
const EUR = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const USD = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const PERCENT = new Intl.NumberFormat('es-ES', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const NUMBER = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 });
const INT = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 });

// Fechas SIEMPRE en formato español dd/mm/yyyy con ceros a la izquierda
// (estándar del holding). NO usar toLocaleDateString/toLocaleString sin
// opciones: el resultado depende del navegador y no garantiza dd/mm/yyyy.
const DATE_FMT = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
const DATETIME_FMT = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

export const fmt = {
  eur: (v: number | string | null | undefined): string => {
    if (v === null || v === undefined || v === '') return '—';
    const n = Number(v);
    return Number.isFinite(n) ? EUR.format(n) : '—';
  },
  usd: (v: number | string | null | undefined): string => {
    if (v === null || v === undefined || v === '') return '—';
    const n = Number(v);
    return Number.isFinite(n) ? USD.format(n) : '—';
  },
  pct: (v: number | string | null | undefined): string => {
    if (v === null || v === undefined || v === '') return '—';
    const n = Number(v) / 100;
    return Number.isFinite(n) ? PERCENT.format(n) : '—';
  },
  number: (v: number | string | null | undefined): string => {
    if (v === null || v === undefined || v === '') return '—';
    const n = Number(v);
    return Number.isFinite(n) ? NUMBER.format(n) : '—';
  },
  int: (v: number | string | null | undefined): string => {
    if (v === null || v === undefined || v === '') return '—';
    const n = Number(v);
    return Number.isFinite(n) ? INT.format(n) : '—';
  },
  date: (v: string | Date | null | undefined): string => {
    if (!v) return '—';
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? '—' : DATE_FMT.format(d);
  },
  datetime: (v: string | Date | null | undefined): string => {
    if (!v) return '—';
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? '—' : DATETIME_FMT.format(d);
  },
};
